import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {helper} from "../../../utils/helper";
import {dashboardActions} from "../../../modules/dashboard/dashboard.actions";
import {Menu, MenuItem, Stack} from "@mui/material";
import {OpenInNew} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import './DashboardViewV2.css';
import "react-circular-progressbar/dist/styles.css";
import Loader from "../layout/loading/loader.js";
import DashboardModalDetailsWorkDone from "./modals/DashboardModalDetailsWorkDone.js";
import {campaignsActions} from "../../../modules/campaigns/campaigns.actions.js";
import DashboardHeaderControls from "./ui/DashboardHeaderControls.js";
import ClientAccordion from "./ui/ClientAccordion.js";
import {dashboardHelper} from "./utils/dashboardHelper.js";
import LaveuseCard from "./ui/LaveuseCard.js";
import DashboardEquipageModal from "./modals/DashboardEquipageModal.js";
import DashboardFormModal from "./modals/DashboardFormModal.js";
import DashboardTitreModal from "./modals/DashboardTitreModal.js";
import Constants from "../../../utils/constants.js";

const MODAL_VIEW = {
    MODAL_VIEW_FULL: 1,
    MODAL_VIEW_IMPOSSIBLE: 2
}

function DashboardView({data, loading, error, dispatch, onModeChange, ...props}) {
    const [selectedDate, setSelectedDate] = React.useState(dashboardHelper.formatDateRelative(0))
    const [selectedTournee, setSelectedTournee] = React.useState(null);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [modalView, setModalView] = React.useState(MODAL_VIEW.MODAL_VIEW_FULL);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [tourneeToEdit, setTourneeToEdit] = React.useState(null);
    const [equipageModalOpen, setEquipageModalOpen] = React.useState(false);
    const [formModalOpen, setFormModalOpen] = React.useState(false);
    const [titreModalOpen, setTitreModalOpen] = React.useState(false);
    let currentUser = helper.getCurrentUser();

    const handleOpenMenu = (event, tournee) => {
        setAnchorEl(event.currentTarget);
        setTourneeToEdit(tournee);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleOpenEquipageModal = () => {
        setEquipageModalOpen(true);
        handleCloseMenu();
    };

    const handleCloseEquipageModal = () => {
        setEquipageModalOpen(false);
        setTourneeToEdit(null);
    };

    const handleOpenFormModal = () => {
        setFormModalOpen(true);
        handleCloseMenu();
    };

    const handleCloseFormModal = () => {
        setFormModalOpen(false);
        setTourneeToEdit(null);
    };

    const handleOpenTitreModal = () => {
        setTitreModalOpen(true);
        handleCloseMenu();
    };

    const handleCloseTitreModal = () => {
        setTitreModalOpen(false);
        setTourneeToEdit(null);
    };

    const loadData = (forceReload = false) => {
        if (!loading && (!error || forceReload)) {
            let values = {exploitantId: currentUser?.id, date: selectedDate};
            dispatch(dashboardActions.fetchDashboardDataV2(values));
        }
    };


    useEffect(() => {
        if (!data) {
            loadData();
        }
        const intervalId = setInterval(loadData, 900000); // 900000 ms = 15 minutes

        // Nettoyage de l'effet
        return () => clearInterval(intervalId);
    }, [currentUser, dispatch]);



    const handleOpenModal = (tourneeId, date, onlyImpossible = false) => {
        if (onlyImpossible) {
            setModalView(MODAL_VIEW.MODAL_VIEW_IMPOSSIBLE)
        } else {
            setModalView(MODAL_VIEW.MODAL_VIEW_FULL)
        }
        setSelectedTournee({tourneeId, date});
        setModalOpen(true);
    };

    const onChauffeurChange = (tourneeId, operateur) => {
        setTourneeToEdit((prev) => ({
            ...prev,
            chauffeur: operateur.id
        }));

    }

    const onEquipierChange = (tourneeId, operateur) => {
        setTourneeToEdit((prev) => {
            if (operateur && operateur.id !== undefined && operateur.id !== "") {
                return {
                    ...prev,
                    equipier: operateur.id,
                };
            } else {
                // suppression de la clé equipier
                const {equipier, ...rest} = prev;
                return rest;
            }
        });
    };


    const onEquipageChange = () => {
        let values = {
            id: tourneeToEdit.id,
            chauffeur: "/api/operateurs/" + tourneeToEdit.chauffeur,
            equipier: null
        }

        if (tourneeToEdit.equipier) {
            values.equipier = "/api/operateurs/" + tourneeToEdit.equipier
        }

        dispatch(campaignsActions.updateCampaign(values, false))
            .then(() => {
                handleCloseEquipageModal()
                loadData(true)
            })
            .catch(() => {
                // Erreur déjà toastée par l'action : on laisse la modal ouverte pour réessayer
            })
    }

    const onTitreChange = (tourneeId, libelle) => {
        let values = {
            id: tourneeId,
            libelle: libelle
        }

        dispatch(campaignsActions.updateCampaign(values, false))
            .then(() => {
                handleCloseTitreModal()
                loadData(true)
            })
            .catch(() => {
                // Erreur déjà toastée par l'action : on laisse la modal ouverte pour réessayer
            })
    }

    const onFormChange = (tourneeId, formId) => {
        let values = {
            id: tourneeId,
            formulaire: formId
        }

        dispatch(campaignsActions.updateCampaign(values, false))
            .then(() => {
                handleCloseFormModal()
                loadData(true)
            })
            .catch(() => {
                // Erreur déjà toastée par l'action : on laisse la modal ouverte pour réessayer
            })
    }

    return (
        <Grid container>
            <DashboardHeaderControls
                selectedDate={selectedDate}
                onDateChange={(date) => {
                    setSelectedDate(date)
                    dispatch(dashboardActions.fetchDashboardDataV2({exploitantId: currentUser?.id, date}))
                }}
                onReload={() => loadData(true)}
                lastUpdated={data?.lastUpdated}
                viewMode={Constants.DASHBOARD_VIEW_MODE_LIST}
                onViewModeChange={onModeChange}
            />

            {loading &&
                <Grid item size={12}>
                    <Loader/>
                </Grid>
            }
            {!loading &&
                <>
                    {/* LAVEUSES */}
                    <Stack sx={{width: "100%", marginTop: "2rem"}} direction={"row"} spacing={1} flexWrap={"wrap"}
                           useFlexGap>
                        {data && data.laveuses && data.laveuses.map((laveuse, id) => {
                            return (
                                <LaveuseCard
                                    key={laveuse.id}
                                    laveuse={laveuse}
                                    selectedDate={selectedDate}
                                />
                            )
                        })}
                    </Stack>

                    {/* DASHBOARD (CLIENT) */}
                    <Stack sx={{width: "100%", marginTop: "2rem"}}>
                        {data && data.clients && Object.entries(data?.clients).map(([client, clientData]) => (
                            <ClientAccordion
                                key={client}
                                client={client}
                                data={clientData}
                                selectedDate={selectedDate}
                                onTourneeDetailClick={handleOpenModal}
                                onTourneeImpossibleClick={handleOpenModal}
                                onlyShowImpossible={modalView === MODAL_VIEW.MODAL_VIEW_IMPOSSIBLE}
                                onMenuClick={handleOpenMenu}
                            />
                        ))}

                    </Stack>

                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleCloseMenu}
                    >
                        <MenuItem onClick={handleOpenEquipageModal}>Modifier l’équipage</MenuItem>
                        <MenuItem onClick={handleOpenFormModal}>Modifier le formulaire</MenuItem>
                        <MenuItem onClick={handleOpenTitreModal}>Modifier le titre</MenuItem>
                        {tourneeToEdit && (
                            <MenuItem
                                component="a"
                                href={(tourneeToEdit.type === 'graffiti'
                                    ? Constants.APP_ROUTE_ADMIN_TOURNEES_GRAFFITI_EDIT
                                    : Constants.APP_ROUTE_ADMIN_CAMPAIGNS_EDIT
                                ).replace(':id', tourneeToEdit.id)}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={handleCloseMenu}
                            >
                                Éditer la tournée
                                <OpenInNew sx={{fontSize: 14, ml: 0.5, color: 'text.secondary'}}/>
                            </MenuItem>
                        )}
                    </Menu>
                </>
            }

            {modalOpen && selectedTournee && (
                <DashboardModalDetailsWorkDone
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    tourneeId={selectedTournee.tourneeId}
                    date={selectedTournee.date}
                    onlyShowImpossible={modalView === MODAL_VIEW.MODAL_VIEW_IMPOSSIBLE}
                />
            )}

            <DashboardEquipageModal
                open={equipageModalOpen}
                onClose={handleCloseEquipageModal}
                tournee={tourneeToEdit}
                onChauffeurChange={onChauffeurChange}
                onEquipierChange={onEquipierChange}
                onSave={onEquipageChange}
                loading={props.campagneUpdateLoading}
            />

            <DashboardFormModal
                open={formModalOpen}
                onClose={handleCloseFormModal}
                tournee={tourneeToEdit}
                onSave={onFormChange}
                loading={props.campagneUpdateLoading}
            />

            <DashboardTitreModal
                open={titreModalOpen}
                onClose={handleCloseTitreModal}
                tournee={tourneeToEdit}
                onSave={onTitreChange}
                loading={props.campagneUpdateLoading}
            />

        </Grid>)
}


const mapStateToProps = function (state) {
    return {
        data: state.dashboard.datav2,
        loading: state.dashboard.loading,
        campagneUpdateLoading: state.campaigns.loading,
        error: state.dashboard.error,
        forms: state.forms.clientForms,
        formsLoading: state.forms.loading
    }
}

export default connect(mapStateToProps)(DashboardView);
